import React, { useMemo } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TIER_COLORS = { Good: '#fb923c', Better: '#3b82f6', Best: '#22c55e' };

// Counts open (unsold) estimates by GBB tier
export default function GBBEstimatesChart({ data }) {
  const chartData = useMemo(() => {
    const buckets = { Good: 0, Better: 0, Best: 0 };
    (data || []).forEach(e => {
      if (e.status !== 'Sold' && buckets[e.tier] !== undefined) buckets[e.tier]++;
    });
    return Object.entries(buckets).map(([name, count]) => ({ name, count, fill: TIER_COLORS[name] }));
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
        <Tooltip />
        <Bar dataKey="count" name="Open Estimates" radius={[4, 4, 0, 0]}>
          {chartData.map((entry, i) => (
            <Cell key={i} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
